import { useMutation } from "@apollo/client";
import { toast } from "react-toastify";
import { DeepPartial, useForm } from "react-hook-form";

import { CREATE_THEME } from "../theme.queries";
import { parseParams } from "../../../helpers/clean-object";

import { CreateThemeInput } from "../../../__generated__/globalTypes";
import {
  CreateThemeMutation,
  CreateThemeMutationVariables,
} from "../../../__generated__/CreateThemeMutation";

interface IProps {
  defaultValues: DeepPartial<CreateThemeInput>;
  onCompleted: (id?: number | null) => any;
}

export const useCreateTheme = ({ defaultValues, onCompleted }: IProps) => {
  const form = useForm<CreateThemeInput>({
    mode: "all",
    defaultValues,
  });
  const [mutate, { loading }] = useMutation<
    CreateThemeMutation,
    CreateThemeMutationVariables
  >(CREATE_THEME, {
    refetchQueries: ["ThemesQuery"],
  });

  const submit = async () => {
    if (loading) return;
    try {
      const input = form.getValues();
      const { data } = await mutate({
        variables: {
          input: parseParams(input),
        },
      });

      if (data?.createTheme?.ok) {
        onCompleted(data.createTheme.id);
      } else {
        throw Error(data?.createTheme?.error ?? "Error");
      }
    } catch (error: any) {
      toast.error(error?.message ?? "Une erreur est survenue");
    }
  };
  return {
    form,
    mutate,
    loading,
    submit,
  };
};
